import React from 'react';

import { useTranslation } from 'react-i18next';

import { Menu } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';

import { TabType } from '../../BaseTabsRouting';

type Props = {
  open: boolean;
  handleClose: () => void;
  componentName: string;
  setTabbedElement: React.Dispatch<TabType>;
  tabulatedItems: TabType[];
  anchorEl: any;
  page: string;
};

// Base element for Subheaders menu items
export const MenuItems: React.FC<Props> = ({
  handleClose,
  tabulatedItems,
  anchorEl,
  setTabbedElement,
  open,
  page
}) => {
  const { t } = useTranslation('common');

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        {tabulatedItems.map((currentTab, i) => (
          <MenuItem
            color="neutral"
            key={i}
            onClick={() => {
              handleClose();
              setTabbedElement(currentTab);
            }}
            component="a"
            href={`/#${page}&page=${currentTab.name.toLowerCase()}`}
          >
            {t(`tableTabs.${currentTab.name}`)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
